import React from "react";
import ArrowCircleUpIcon from "@mui/icons-material/ArrowCircleUp";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import ReceiptOutlinedIcon from "@mui/icons-material/ReceiptOutlined";
import Approval from "@mui/icons-material/Approval";
import PendingActions from "@mui/icons-material/PendingActions";
import Info from "@mui/icons-material/Info";

import HomeIcon from "@mui/icons-material/Home";
import { currencyFormatter } from "../../helpers/currencyHelper";

export function Indicator({ title, value, color }) {
  const drawIcon = () => {
    const iconStyle = { fontSize: "22px", color: "currentColor" };
    switch (title) {
      case "Sites":
        return <HomeIcon style={iconStyle} />;
      case "TR Recom.":
        return <PendingActions style={iconStyle} />;
      case "TR Appr.":
        return <Approval style={iconStyle} />;
      case "$ Recom.":
        return <PendingActions style={iconStyle} />;
      case "$ Approved":
        return <Approval style={iconStyle} />;
      case "Total Repairs":
        return <ArrowCircleUpIcon style={iconStyle} />;
      case "Open Quotes":
        return <EventAvailableIcon style={iconStyle} />;
      case "Approved Quotes":
        return <Approval style={iconStyle} />;
      case "No Damage Found":
        return <EventAvailableIcon style={iconStyle} />;
      case "Scheduled Jobs":
        return <EventAvailableIcon style={iconStyle} />;
      case "Closed Jobs":
        return <EventAvailableIcon style={iconStyle} />;
      case "Open Invoices":
        return <ReceiptOutlinedIcon style={iconStyle} />;
      default:
        return <Info style={iconStyle} />;
    }
  };

  const convertMoney = (value) => {
    return currencyFormatter(value);
  };

  const getLightBg = (c) => {
    if (!c) return "rgba(37, 99, 235, 0.12)";
    if (c.startsWith("#")) {
      const r = parseInt(c.slice(1, 3), 16);
      const g = parseInt(c.slice(3, 5), 16);
      const b = parseInt(c.slice(5, 7), 16);
      return `rgba(${r}, ${g}, ${b}, 0.13)`;
    } else if (c.startsWith("rgb")) {
      return c.replace("rgb", "rgba").replace(")", ", 0.13)");
    }
    return "rgba(37, 99, 235, 0.12)";
  };

  const getStrongBg = (c) => {
    if (!c) return "rgba(37, 99, 235, 0.24)";
    if (c.startsWith("#")) {
      const r = parseInt(c.slice(1, 3), 16);
      const g = parseInt(c.slice(3, 5), 16);
      const b = parseInt(c.slice(5, 7), 16);
      return `rgba(${r}, ${g}, ${b}, 0.24)`;
    } else if (c.startsWith("rgb")) {
      return c.replace("rgb", "rgba").replace(")", ", 0.24)");
    }
    return "rgba(37, 99, 235, 0.24)";
  };

  const displayValue =
    title === "Open Invoices" ? convertMoney(value) : String(value ?? "");
  const valueLength = String(displayValue).length;
  const valueSizeClass =
    valueLength >= 12
      ? "indicator-value--small"
      : valueLength >= 9
      ? "indicator-value--compact"
      : "";

  return (
    <div
      className="indicator-card"
      style={{
        "--indicator-color": color,
        "--indicator-soft": getLightBg(color),
        "--indicator-strong": getStrongBg(color),
      }}
    >
      <div className="indicator-card__glow" />
      <div
        className="indicator-icon-wrapper"
      >
        {drawIcon()}
      </div>
      <div className="indicator-content">
        <div className="indicator-content__header">
          <span className="indicator-title">{title}</span>
          <span className="indicator-dot" />
        </div>
        <span className={`indicator-value ${valueSizeClass}`}>
          {displayValue}
        </span>
      </div>
    </div>
  );
}
